import classNames from "classnames"
import PropTypes from "prop-types"
import React from "react"

import { formatCurrencyFromMinorUnits } from "src/utils/UnitConversion"

const STANDARD_VARIANT = "standard"
const RED_VARIANT = "red"

const BalanceCard = ({
  title,
  icon,
  amountInCents,
  description,
  onClick,
  variant = STANDARD_VARIANT,
  selected = false,
  currency = "USD",
}) => {
  return (
    <div
      role="button"
      onClick={onClick}
      className={classNames(
        "flex flex-1 flex-col space-y-4 rounded border px-6 py-4",
        {
          "border-gray-300": !selected,
          "border-blue-600 bg-blue-50": selected,
          "cursor-pointer hover:border-blue-600 hover:bg-blue-50":
            typeof onClick === "function",
          "cursor-default": typeof onClick !== "function",
        }
      )}
    >
      <div className="flex flex-row items-center space-x-1">
        <i
          className={classNames(`fa-solid ${icon} text-base`, {
            "text-red-600": variant === RED_VARIANT,
            "text-blue-500": variant === STANDARD_VARIANT,
          })}
        />
        <div>{title}</div>
      </div>
      <div
        className={classNames("text-4xl font-bold", {
          "text-red-600": variant === RED_VARIANT,
        })}
      >
        {formatCurrencyFromMinorUnits({ amount: amountInCents, currency })}
      </div>
      <div className="text-gray-600">{description}</div>
    </div>
  )
}

BalanceCard.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  amountInCents: PropTypes.number.isRequired,
  description: PropTypes.string.isRequired,
  variant: PropTypes.oneOf([STANDARD_VARIANT, RED_VARIANT]),
  onClick: PropTypes.func,
  selected: PropTypes.bool,
  currency: PropTypes.string,
}
export default BalanceCard
